<div mat-dialog-title>
    <div class="flex error-icon"><mat-icon svgIcon="notification-error"></mat-icon></div>
  </div>

  <div mat-dialog-content>
    <p class="text"> Please contact T1D Exchange Registry study staff at <a href="mailto:registry@T1DExchange.org">Registry&#64;T1DExchange.org</a>
        for help updating your notification settings.</p>
  </div>

  <div mat-dialog-actions>
    <button class="dialog-button" mat-flat-button color="primary" [mat-dialog-close]="null">Close</button>
  </div>